import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("jwt");

  return token ? <Navigate to="/" replace /> : children;
};

export default PublicRoute;
